import type { CSSProperties, ReactNode } from "react";

export const FLOAT_LIFETIME_MS = 1200;
export const BANNER_LIFETIME_MS = 1800;

/** Playback time is supplied by the replay; neither lifetime nor motion uses wall time. */
export function FloatingNumber({
  born,
  time,
  color,
  children,
}: {
  born: number;
  time: number;
  color: string;
  children: ReactNode;
}) {
  const progress = Math.max(0, (time - born) / FLOAT_LIFETIME_MS);
  if (progress >= 1) return null;
  const style: CSSProperties = {
    color,
    animation: "none",
    transform: `translate(-50%, ${-22 * progress}px) scale(${1 + 0.1 * progress})`,
    opacity: 1 - progress,
  };
  return (
    <span className="float-num" style={style}>
      {children}
    </span>
  );
}

export function UltimateBanner({
  born,
  time,
  color,
  children,
}: {
  born: number;
  time: number;
  color: string;
  children: ReactNode;
}) {
  const age = Math.max(0, time - born);
  if (age >= BANNER_LIFETIME_MS) return null;
  return (
    <div className="ult-banner" style={{ borderColor: color, color }} data-testid="ult-banner">
      {children}
    </div>
  );
}
